import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import TextDate from 'components/text/TextDate';


// const InputDate = ({value, onChange }) => {
//     const [dbInput, setdbInput] = useState(); 
//     function click (dpInput) {
//             dpInput.onInputClick();
//             dpInput.setFocus();
//           }

//     return (
//         <div
//         className="form"
//         style={{ width: '140px', position: 'relative', display: 'inline-block' }}>
//              <ReactDatePicker
//                 className="text-gray-darker"
//                 ref={instance => setdbInput(instance)}
//                 onChange={onChange}
//                 selected={value}
//                 dateFormat="dd.MM.yyyy"
//                 />
//            <i className="icon-calendar cursor-pointer text-gray-darker"
//                 onClick={ ()=>click(dpInput)}
//                 style={{ position: 'absolute', top: 5, right: 10 }}
//             />
//         </div>
//     );
// }

class InputDate extends Component {
  constructor(props) {
    super(props);
    this.click = this.click.bind(this);
  }

  click() {
    this.dpInput.onInputClick();
    this.dpInput.setFocus();
  }  

  render() {
    const { value, onChange, disabled } = this.props;

    if (disabled){
      return (<span>{(value == null ? "" : <TextDate value={value}/>)}</span>)
    }

    return (
      <div
        className="form"
        style={{ width: '140px', position: 'relative', display: 'inline-block' }}
      >
        <ReactDatePicker
          className="text-gray-darker"
          ref={instance => (this.dpInput = instance)}
          onChange={onChange}
          selected={value}
          dateFormat={"dd.MM.yyyy"}
          todayButton={"Today"}          
        />
        <i
          className="icon-calendar cursor-pointer text-gray-darker"
          onClick={this.click}
          style={{ position: 'absolute', top: 5, right: 10 }}
        />
      </div>
    );
  }
}

InputDate.propTypes = {
  value: PropTypes.object,
  disabled : PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

export default InputDate;
